import type { App, DirectiveBinding } from 'vue';

import { operationCan } from '#nora-ui/utils/permission';

// v-can directive
export function installAccessManagement(app: App): void {
  app.directive('can', canDirective);
}

type PermissionCheck
  = | string
    | {
      permission: string;
    };

function canDirective(element: HTMLElement, binding: DirectiveBinding<PermissionCheck>): void {
  const permissionCheck: PermissionCheck = binding.value;
  const permission
    = typeof permissionCheck === 'string'
      ? permissionCheck
      : permissionCheck.permission;

  if (operationCan(permission)) {
    show(element);

    return;
  }

  hide(element);
}

function hide(element: HTMLElement): void {
  element.style.setProperty('display', 'none', 'important');
}

function show(element: HTMLElement): void {
  element.style.removeProperty('display');
}
